import { useHistory } from 'react-router-dom'
import { UnlockButton } from 'blaze-components/WriterTopBar/UnlockButton'
import { Button as MobileButton } from 'common/Prose/Toolbar/ToolbarBravo/WriterFormatToolbar/Button'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { sendMessageToNativeApp } from 'utils/sendMessageToNativeApp'

export const BackButton = () => {
  const history = useHistory()
  const { isIOSNative } = useResponsiveDesign()

  // If coming from a different site than Blaze
  // But never display Unlock in webview.
  if (history.action === 'POP' && !isIOSNative) {
    return <UnlockButton />
  }

  if (isIOSNative) {
    return (
      <MobileButton
        onPress={() => {
          // Post a message to the webview to handle the close button press
          sendMessageToNativeApp('closeButtonPressed')
          history.goBack()
        }}
        aria-label="Close"
      >
        Close
      </MobileButton>
    )
  }

  return (
    <MobileButton onPress={() => history.goBack()} aria-label="Back">
      Back
    </MobileButton>
  )
}
